import React from "react";
import {
  ChevronRight,
  Leaf,
  LucidePill,
  ShoppingCart,
  Smartphone,
} from "lucide-react";
import Card from "../Card/Card";

interface HealthStoreCardProps {
  componentData: {
    description: string;
    id: string;
    options: {
      id: string;
      title: string;
      description: string;
      link: string;
    }[];
    title: string;
    type: string;
    view_all_link: string;
  };
}

const HealthStoreCard: React.FC<HealthStoreCardProps> = ({ componentData }) => {
  const icons = {
    nutraceuticals: <Leaf className="w-5 h-5 text-[var(--app-primary)]" />,
    pharmacy: <LucidePill className="w-5 h-5 text-[var(--app-primary)]" />,
    "care-products": (
      <ShoppingCart className="w-5 h-5 text-[var(--app-primary)]" />
    ),
    "smart-devices": (
      <Smartphone className="w-5 h-5 text-[var(--app-primary)]" />
    ),
  };

  return (
    <div className="mx-4">
      <Card
        title={componentData?.title}
        description={componentData?.description}
        icon={<ShoppingCart className="w-4 h-4" />}
        rightIcon={<ChevronRight className="w-4 h-4" />}
        rightIconClick={() => {
          window.open(componentData?.view_all_link, "_blank");
        }}
      >
        <div className="flex items-center gap-2 overflow-x-auto">
          {componentData?.options?.map((option: any) => (
            <button
              key={option.title}
              className="flex flex-col items-center gap-3 p-4 bg-[var(--icon-bg-primary)] border-[var(--app-primary)] rounded-md min-w-[120px] h-full"
              onClick={() => {
                window.open(option.link, "_blank");
              }}
            >
              {option.id in icons
                ? icons[option.id as keyof typeof icons]
                : null}
              <div className="text-xs font-medium text-black text-center">
                {option.title}
              </div>
            </button>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default HealthStoreCard;
